// @flow

import { titleToSlug } from '../../../services/titleToSlug'

export default {
  productID: 'hardCoded.productID.complotIPABottle',
  title: 'hardCoded.title.complotIPABottle',
  slug: titleToSlug('hardCoded.title.complotIPABottle'),
  hideFromSite: true
}
